import { createEventId } from "./events";

const STORAGE_KEY_PREFIX = "conan.quiz.quiz-start-event.v1.";
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function storage(): Storage | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    return window.sessionStorage;
  } catch {
    return undefined;
  }
}

/**
 * Keeps QuizStart stable when browser providers are enabled after the quiz
 * session was created. The shared ID preserves cross-provider deduplication.
 */
export function getQuizStartEventId(sessionId: string): string {
  const normalizedSessionId = sessionId.trim();
  if (!normalizedSessionId) throw new TypeError("Quiz session ID is required");
  const key = `${STORAGE_KEY_PREFIX}${normalizedSessionId}`;
  try {
    const existing = storage()?.getItem(key);
    if (existing && UUID_PATTERN.test(existing)) return existing;
    const eventId = createEventId();
    storage()?.setItem(key, eventId);
    return eventId;
  } catch {
    return createEventId();
  }
}
